<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "admin-lte/plugins/fontawesome-free/css/all.min.css";
import "admin-lte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css";
import "admin-lte/plugins/icheck-bootstrap/icheck-bootstrap.min.css";
import "admin-lte/plugins/jqvmap/jqvmap.min.css";
import "admin-lte/dist/css/adminlte.css";
import "admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css";
import "admin-lte/plugins/daterangepicker/daterangepicker.css";
import "admin-lte/plugins/summernote/summernote-bs4.min.css";

export default {};
</script>

<style>

@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css");
:root {
  --bg-round-a: #ed1c24;
}
/* Scroll bar stylings */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--lightestgrey);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

.route-is-active {
  color: #FFFFFF!important;
  background-color: #2f303a!important;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.form-control.border-danger,
.form-control.border-danger ~ .input-group-append {
  animation-name: shakeError;
  animation-fill-mode: forwards;
  animation-duration: 0.6s;
  animation-timing-function: ease-in-out;
}
@keyframes shakeError {
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(0.2rem);
  }
  30% {
    transform: translateX(-0.2rem);
  }
  45% {
    transform: translateX(0.2rem);
  }
  60% {
    transform: translateX(-0.2rem);
  }
  75% {
    transform: translateX(0.2rem);
  }
  90% {
    transform: translateX(-0.2rem);
  }
  100% {
    transform: translateX(0);
  }
}
.btn-utama {
    color: #fff!important;
    background-color: var(--bg-round-a)!important;
    border-color: var(--bg-round-b)!important;
    box-shadow: none;
}
.btn-outline-utama {
    color: var(--bg-round-a)!important;
    border-color: var(--bg-round-b)!important;
}
.btn-outline-utama:hover {
  color: #ffffff!important;
  background-color: var(--bg-round-a)!important;
}
.link-utama {
    color: var(--bg-round-a);
}
.link-utama:hover {
    color: #222;
}
.card-header-utama {
    background-color: var(--bg-round-a);
}
.card-footer {
  display: flex;
  flex: 1 1 0px
}
.card-footer > .btn {
  width: 100%;
}
</style>
